import * as Yup from 'yup'
import LookupType from './LookupType'

const GuniteDetails = Yup.object().shape({
    id: Yup.number(),
    job_detail_id: Yup.number().nullable(),
    finished_date: Yup.string().nullable(),
    total_yardage: Yup.string().nullable(),
    flash_yards: Yup.string().nullable(),

    gunite_history: Yup.array().of(Yup.object().shape({
        id: Yup.number().nullable(),
        job_detail_id: Yup.number().nullable(),
        gunite_date: Yup.string().nullable().when(['type'], {
            is: (type) => type && type.id && type.id > 1 && type.id < 9,
            then: Yup.string().required('Required')
        }),
        status: LookupType.nullable(),
        crew: LookupType.nullable(),
        type: LookupType.test('is-valid-type', 'Required', (value) => value && value.id).typeError('Required'),
        yardage: Yup.string().nullable(),
        job_order: LookupType.nullable(),
        notes: Yup.string().nullable()
    })).nullable()
})

const SubjobSchema = Yup.object().shape({
    id: Yup.number().nullable(),
    mmg_perimeter: Yup.string().nullable(),
    status: LookupType.nullable(),
    job_category: LookupType,
    awaiting_builder_date: Yup.string().nullable(),

    gunite_details: GuniteDetails
})

export const DailyYardageSchema = Yup.object().shape({
    id: Yup.string().nullable(),

    sub_jobs: Yup.array().of(SubjobSchema)
})